export var MediumPrefix;
(function (MediumPrefix) {
    MediumPrefix["PRICE_MAP"] = "price_map";
})(MediumPrefix || (MediumPrefix = {}));
